import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
export var EAlignment;

(function (EAlignment) {
  EAlignment["Center"] = "center";
  EAlignment["Left"] = "left";
  EAlignment["Right"] = "right";
})(EAlignment || (EAlignment = {}));

export function FormFieldHelper(props) {
  var _cn;

  var _props$alignment = props.alignment,
      alignment = _props$alignment === void 0 ? EAlignment.Left : _props$alignment,
      _props$marginBottom = props.marginBottom,
      marginBottom = _props$marginBottom === void 0 ? false : _props$marginBottom;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles['cont'], (_cn = {}, _defineProperty(_cn, styles['align-center'], alignment === EAlignment.Center), _defineProperty(_cn, styles['align-left'], alignment === EAlignment.Left), _defineProperty(_cn, styles['align-right'], alignment === EAlignment.Right), _defineProperty(_cn, styles['margin-bottom'], marginBottom), _cn))
  }, props.children);
}